export default __webpack_public_path__ + "static/media/nguyenthan.24ba2970.png";